module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/bg-cba41cfc59b3ffcbeafe899be7523acd.png";